export const MIN_SHIFTS_PER_WEEK = 0;



// Shift swap requests (soldier "בקש החלפה" + admin approval). Hidden for now;
// flip to true to bring the feature back everywhere.
export const SWAP_REQUESTS_ENABLED = false;
